// removed by extract-text-webpack-plugin
module.exports = {"link":"src-components-project-project-button----project-button-module---link---2Atqc"};


//////////////////
// WEBPACK FOOTER
// ./src/components/project/project-button/project-button.module.css
// module id = 512
// module chunks = 168707334958949